module.exports = __webpack_public_path__ + "img/album07_29.39934280.jpg";